import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Action, Store } from '@ngrx/store';
import { TslDialog } from '@tesla/ng-tds';
import { StatusEnum } from 'app/profile/models/state.model';
import { SupplierAddressPropertyValues, SupplierContactPropertyValue } from 'app/profile/models/supplier.model';
import { CommonService } from 'app/profile/services/common.service';
import { ProfileService } from 'app/profile/services/profile.service';
import { StateService } from 'app/profile/services/state.service';
import { SupplierStateService } from 'app/profile/services/supplierstate.service';
import { SupplierProfileState } from 'app/profile/store/app.reducer';
import { SelectSupplierContactList } from 'app/profile/store/app.selector';
import { I18nService } from 'app/shared/services/i18n.service';
import {
  LinkDelinkSupplierAddressContacts, LinkDelinkSupplierAddressContactsSuccess, LINK_DELINK_SUPPLIER_ADDRESS_CONTACTS_SUCCESS
} from 'app/profile/store/actions/supplierstate.action';
import { Subscription } from 'rxjs-compat';
import { Actions, ofType } from '@ngrx/effects';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-address-delink-dialog',
  templateUrl: './address-delink-dialog.component.html',
  styleUrls: ['./address-delink-dialog.component.scss']
})
export class AddressDelinkDialogComponent implements OnInit {

  contactForm: FormGroup;
  subscription: Subscription = {} as Subscription;
  contactList: Contact[];
  supplierCode: string;
  locationId: number;
  warehouseContacts: any;
  private unsubscribe$ = new Subject<void>();

  constructor(private fb: FormBuilder,
    public dialogRef: MatDialogRef<AddressDelinkDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private store: Store<SupplierProfileState>,
    private supplierStateService: SupplierStateService,
    private commonService: CommonService,
    private translateService: I18nService,
    private route: ActivatedRoute,
    private profileService: ProfileService,
    private stateService: StateService,
    private actions$: Actions,
    private dialog: TslDialog) {
    this.subscription = new Subscription();
    this.contactForm = this.fb.group({
      contacts: ['', Validators.required],
    });
  }

  get ContactFormControls() {
    return {
      contacts: this.contactForm.get('contacts'),
    };
  }

  ngOnInit(): void {
    this.warehouseContacts = this.dialogData?.warehouseAddress;
    this.locationId = this.warehouseContacts.locationId.newValue;
    this.supplierCode = this.dialogData?.supplierCode;
    
    const formattedContacts: Contact[] = [];
    this.warehouseContacts.contacts.newValue.forEach(contact => {
      const c = new Contact();
      c.name = contact.name;
      c.email = contact.email;
      c.phone = contact.phone;
      formattedContacts.push(c);
    });
    this.contactList = formattedContacts;
  }

  onClose(): void {
    this.dialogRef.close();
  }

  save() {
    const existingContactsCount = this.dialogData?.warehouseAddress.contacts.newValue?this.dialogData?.warehouseAddress.contacts.newValue.length:0;
    if(this.ContactFormControls.contacts.value.length == existingContactsCount){
      this.dialog
      .alert(
        'Error',
        this.translateService.get('There must be at least one contact linked to the ship from address. Delink all contacts is not allowed.')
      );
      return;
    }
    this.dialog
      .alert(
        'Alert',
        this.translateService.get('This action will only delink the contact from this ship from address. It will not remove a contact from your organizations contact tab.')
      )
      .afterClosed()
      .subscribe(r => {
        let addressContacts = {
          contacts: this.dialogData?.warehouseAddress.contacts.newValue ? this.dialogData?.warehouseAddress.contacts.newValue : [],
          locationId: this.locationId
        };

        const contacts: any[] = this.ContactFormControls.contacts.value;
        const existingContacts = this.dialogData?.warehouseAddress.contacts.newValue;

        addressContacts.contacts = addressContacts.contacts.filter(contact =>
          !contacts.some(c => c.email === contact.email && c.name === contact.name && c.phone == contact.phone)
        );

        if (this.contactForm.valid) {
          this.store.dispatch(new LinkDelinkSupplierAddressContacts({supplierCode: this.supplierCode, contacts: addressContacts}));
        this.actions$.pipe(
          ofType<LinkDelinkSupplierAddressContactsSuccess>(LINK_DELINK_SUPPLIER_ADDRESS_CONTACTS_SUCCESS),
          takeUntil(this.unsubscribe$)
        )
          .subscribe(() => {
            this.stateService.currentStatus.next({ type: StatusEnum.Success, message: 'Contact(s) delinked' });
            this.dialogRef.close(true);
        });
      }
      
      });
  }

  ngOnDestroy(){
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
export class Contact {
  name: string = '';
  email: string = '';
  phone: string = '';

  constructor() { }
}